import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/provider-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/ProviderForm';
import { IProvider } from 'src/types/provider';
import Breadcrumbs from 'src/components/Breadcrumbs';

import { routes } from 'src/navigation';
import { Paginated } from 'src/services/api-handlers/pagination';
import { IServiceType } from 'src/types/service-types';
import { IServiceLocation } from 'src/types/service-locations';
import { QueryParams } from 'src/types/grid';

export interface StateProps {
    provider: IProvider | null;
    serviceTypes: Paginated<IServiceType>;
    files: any;
    providers: { title: string; id: number | string }[];
    providersuper: Paginated<Partial<IProvider>>;
    inProgress: boolean;
    serviceLocations: Paginated<IServiceLocation>;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getFiles: (id: string | number) => void;
    addFiles: (id: string | number, requestType: string, files: any) => void;
    removeFile: (id: string | number) => void;
    getProviders: (params: QueryParams) => void;
    getProvidersSupervisor: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getServiceLocations: (params: QueryParams) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const ProviderEditScreen: FC<Props> = (props: Props) => {
    const {
        provider,
        match: {
            params: { id },
        },
        serviceTypes,
        getFiles,
        files,
        addFiles,
        providers,
        providersuper,
        removeFile,
        inProgress,
        serviceLocations,
        getServiceTypes,
        getServiceLocations,
        getData,
        getProviders,
        getProvidersSupervisor,
    } = props;

    useEffect(() => {
        getServiceTypes({
            page: 1,
            itemsPerPage: 1200,
        });
        getServiceLocations({
            page: 1,
            itemsPerPage: 1200,
        });

        if (!provider || provider.id !== id) {
            getData(id);
            getFiles(id);
            getProvidersSupervisor({
                filters: {
                    'supervisor.id': id,
                },
                page: 1,
                itemsPerPage: 1200,
            });
            getProviders({ page: 1, itemsPerPage: 9000 });
        }
        // eslint-disable-next-line
    }, [getServiceTypes, getFiles, getData, getServiceLocations, getProviders, id]);

    const handeAdd = (files: any, requestType: string) => {
        addFiles(id, requestType, files);
    };
    const handeRemove = (fileId: string | number) => {
        removeFile(fileId);
    };

    const serviceLocationsValues: { label: string; value: number }[] = [];
    const serviceTypesValues: { label: string; value: number }[] = [];
    const providersValues: { label: string; value: number }[] = [];

    provider?.userServiceLocations.forEach((itData: any) => {
        serviceLocationsValues.push({ label: itData.serviceLocation.title, value: itData.serviceLocation.id });
    });

    provider?.userServiceTypes.forEach((itData: any) => {
        serviceTypesValues.push({ label: itData.serviceType.title, value: itData.serviceType.id });
    });
    provider?.providers?.forEach((itData: any) => {
        providersValues.push({ label: itData.provider.title, value: itData.provider.id });
    });
    const serValues: any = [];
    serviceTypes.list.forEach((serv: any) => {
        const title = serv.title ? serv.title : serv.cpt;

        serValues.push({ ...serv, title });
    });

    const provInitVal: SelectObject[] = [];

    providersuper.list.forEach((prov: any) => {
        const title = prov.provider?.fullName ? prov.provider?.fullName : '';
        const idProvider = prov?.id ?? +prov.id;
        if (!!provider?.userProviders.find((it: any) => +it?.id === idProvider)) {
            provInitVal.push({ value: prov.provider?.id, label: title });
        }

        //  provValues.push({ id: prov.provider?.id, title });
    });

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'PROVIDERS', path: routes.PROVIDERS_LIST },
                    { name: `EDIT ${provider?.fullName ? provider?.fullName : ''}`, path: '' },
                ]}
            />

            <div className={classNames(styles.editWrap)}>
                {inProgress ? <Loader /> : !provider ? <div></div> : null}
                <Form
                    handleSub={(handleSubmit: (e: any) => void, e: any) => {
                        handleSubmit(e);
                    }}
                    serviceTypes={serValues}
                    serviceLocations={serviceLocations}
                    files={files ? files : []}
                    providers={providers}
                    signDoc={provider?.signDoc}
                    setSignDoc={(files) => handeAdd(files, 'SIGNDOC')}
                    setFiles={(files: any) => handeAdd(files, 'OTHER')}
                    removeFile={(id) => handeRemove(id)}
                    initialValues={{
                        ...provider,
                        serviceLocations: serviceLocationsValues,
                        serviceTypes: serviceTypesValues,
                        providers: provInitVal,
                        referredByDropDown: {
                            value: provider?.referredBy ? provider?.referredBy?.id : '',
                            label: provider?.referredBy ? `${provider?.referredBy?.fullName}` : '',
                        },
                    }}
                />
            </div>
        </AdminLayout>
    );
};
export default ProviderEditScreen;
